import React, { useEffect } from "react";
import { Preloader } from "../../Preloader/preloader";
import { addSlaveUser, queryUserUpdateName, $user } from "../../../user";
import { removeValidateMarksRU, validatePhoneRU } from "../../../functions";
import { IAccount } from "../../../accounts2";
import "../Popup.css";
import { toast } from "react-toastify";
import { $SiteColors } from "../../../config/company-atts";

interface IUserPopup {
  openUserPopup: {
    open: boolean;
    type: string;
  };
  setOpenUserPopup: React.Dispatch<
    React.SetStateAction<{ open: boolean; type: string }>
  >;
  user: {
    firstName: string;
    phone: string;
  };
  chosenAcc: IAccount | null;
}

export const UserPopup: React.FC<IUserPopup> = ({
  openUserPopup,
  setOpenUserPopup,
  user,
  chosenAcc,
}) => {
  const [isValid, setIsValid] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [disableInputs, setDisabledInputs] = React.useState(false);
  const [status, setStatus] = React.useState("");
  const [typeObject, setTypeObject] = React.useState<{
    title: string;
    inputName: string;
  } | null>(null);
  const [value, setValue] = React.useState("");

  const overlay = React.useRef<HTMLDivElement>(null);
  const form = React.useRef<HTMLFormElement>(null);

  React.useEffect(() => {
    window.addEventListener("keyup", handleEscClose, false);
    //document.addEventListener("click", overlayClickClose, false);
    return () => {
      window.removeEventListener("keyup", handleEscClose, false);
      //document.removeEventListener("click", overlayClickClose, false);
    };
  }, [disableInputs]);

  React.useEffect(() => {
    if (openUserPopup.type === "name") {
      setTypeObject({
        title: "Смена имени",
        inputName: "firstName",
      });
      setValue(user.firstName || "");
    }
    if (openUserPopup.type === "phone") {
      setTypeObject({
        title: "Смена телефона",
        inputName: "phone",
      });
      setValue(validatePhoneRU(user.phone).phone || "");
    }
    if (openUserPopup.type === "addSlaveUser") {
      setTypeObject({
        title: "Добавление пользователя",
        inputName: "phone",
      });
      setValue("");
    }
  }, [openUserPopup]);

  React.useEffect(() => {
    if (form.current && !showLoader) setIsValid(form.current.checkValidity());
  }, [value]);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target;
    const value = target.value;
    if (
      openUserPopup.type === "phone" ||
      openUserPopup.type === "addSlaveUser"
    ) {
      const digitValue = value.replace(/\D/g, "");
      setValue(validatePhoneRU(digitValue).phone);
    } else {
      setValue(value);
    }
  }

  function handleCloseChangePopup() {
    if (!disableInputs) {
      setOpenUserPopup({ ...openUserPopup, open: false });
      setIsValid(false);
      setStatus("");
    } else {
      setDisabledInputs(false);
      setShowLoader(false);
      setOpenUserPopup({ ...openUserPopup, open: false });
      setIsValid(false);
      setStatus("");
    }
  }

  function handleEscClose(event: KeyboardEvent) {
    if (event.key === "Escape") {
      handleCloseChangePopup();
    }
  }

  /*function overlayClickClose(event: Event) {
    if (overlay.current && overlay.current === event.target) {
      handleCloseChangePopup();
    }
  }*/

  const [showCounter, setShowCounter] = React.useState(false);
  const [verificationId, setVerificationId] = React.useState("");
  const [captcha, setCaptcha] = React.useState<JSX.Element | null>(
    <div id="recaptcha-block"></div>
  );
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [phoneStatus, setPhoneStatus] = React.useState("");
  const [codeStatus, setCodeStatus] = React.useState("");

  useEffect(() => {
    // console.log("showLoader:", showLoader)
    // console.log("showConfirm:", showConfirm)
    // console.log("showCounter:", showCounter)
    // console.log("phoneStatus:", phoneStatus)
    // console.log("disableInputs:", disableInputs)
    // console.log("isValid:", isValid)
    // console.log("verificationId:", verificationId)

  }, [showLoader, showConfirm, showCounter, phoneStatus, disableInputs, isValid, verificationId])

  const onSubmitChangePhone = (phone: string) => {
    setPhoneStatus("");
    setDisabledInputs(true);
    setIsValid(false);
    setShowLoader(true);

    // phoneAuthR(
    //   "recaptcha-block",
    //   removeValidateMarksRU(phone),
    //   setVerificationId,
    //   setShowLoader,
    //   setShowCounter,
    //   setShowConfirm,
    //   setPhoneStatus,
    //   setDisabledInputs,
    //   setIsValid,
    //   setCaptcha,
    //   captcha
    // );
  }

  useEffect(() => {
    if(phoneStatus == "phoneSuccess") {
      let code = prompt("Введите код отправленный на номер ")
      if(code != null) {
        // codeAuthR(code, verificationId, setCodeStatus).then((res) => {
        //   console.log("CODE_SUCCESS_RES:", res)
        //   if (res.status && res.phone) {
        //     console.log("CODE_SUCCESS:", res.status, res.phone)//@ts-ignore
        //     queryUserUpdatePhone({object:{phone: res.phone, login: res.phone},user:$user.getState()})//ИСПРВЛЯИТЬ
        //     .then(() => {
        //       setShowLoader(false);
        //       setDisabledInputs(false);
        //       setIsValid(true);
        //       setStatus("success");
        //     })
        //     .catch(() => {
        //       setShowLoader(false);
        //       setDisabledInputs(false);
        //       setIsValid(true);
        //       setStatus("error");
        //       return user;
        //     });

        //   } else {
        //     toast.error("Неправильный код подтверждения")
        //     console.log("CODE_SUCCESS_NO:")
        //   }
        // }).catch(e => {
        //   console.log("CODE_ERR:", e)
        //   toast.error(e.message)
        // })
      } else {
        setShowLoader(false);
        setDisabledInputs(false);
        setIsValid(true);
        setStatus(""); 
      }
    } else if(phoneStatus == "phoneError") {
      // console.log("Не удалось проверить телефон")
      toast.error("Не удалось проверить телефон")
    }
      
  }, [phoneStatus])

  function handleFormSubmit(event: React.FormEvent) {
    event.preventDefault();
    setShowLoader(true);
    setDisabledInputs(true);
    setIsValid(false);
    let req = {};
    if (openUserPopup.type === "name") {
      req = {
        name: value,
      };
    }
    if (openUserPopup.type === "phone") {
      const phoneNumber = removeValidateMarksRU(value);
      req = {
        phone: phoneNumber,
        login: phoneNumber,
      };
      onSubmitChangePhone(phoneNumber)
      return
    }
    console.log($user.getState())//@ts-ignore
      queryUserUpdateName({object:req,user:$user.getState()})
      .then(() => {
        setShowLoader(false);
        setDisabledInputs(false);
        setIsValid(true);
        setStatus("success");
      })
      .catch(() => {
        setShowLoader(false);
        setDisabledInputs(false);
        setIsValid(true);
        setStatus("error");
        return user;
      });
  }

  function handleAddUser(event: React.FormEvent) {
    event.preventDefault();
    if (chosenAcc) {
      const phoneNumber = removeValidateMarksRU(value);
      addSlaveUser;
      setShowLoader(true);
      setDisabledInputs(true);
      setIsValid(false);

      addSlaveUser(chosenAcc.id, phoneNumber)
        .then(() => {
          setShowLoader(false);
          setDisabledInputs(false);
          setIsValid(true);
          setStatus("success");
        })
        .catch(() => {
          setShowLoader(false);
          setDisabledInputs(false);
          setIsValid(true);
          setStatus("error");
          return user;
        });
    }
  }

  return (
    typeObject && (
      <div
        className={
          openUserPopup.open ? "popup popup_animation popup_opened" : "popup"
        }
        ref={overlay}
      >
        
        <div id="recaptcha-container">{captcha}</div>
        <div className="popup__container">
          <h3 className="popup__title">{typeObject.title}</h3>
          <button
            className="popup__close"
            type="button"
            onClick={handleCloseChangePopup}
          >
            +
          </button>
          <form
            className="popup__form"
            ref={form}
            onSubmit={
              openUserPopup.type === "addSlaveUser"
                ? handleAddUser
                : handleFormSubmit
            }
          >
            {openUserPopup.type === "name" && (
              <input
                type="text"
                className="popup__input popup__input_user"
                placeholder="Введите новое имя"
                name="firstName"
                required
                title="Обязательное для заполнения поле"
                onChange={handleChange}
                disabled={disableInputs}
                value={value}
              ></input>
            )}
            {(openUserPopup.type === "phone" ||
              openUserPopup.type === "addSlaveUser") && (
              <input
                type="tel"
                className="popup__input popup__input_user"
                placeholder={
                  openUserPopup.type === "phone"
                    ? "Введите новый телефон"
                    : "Введите телефон пользователя"
                }
                name="phone"
                required
                title="Обязательное для заполнения поле"
                onChange={handleChange}
                disabled={disableInputs}
                value={value}
                id="phone"
                pattern="\+7\(\d{3}\)\d{3}-\d{2}-\d{2}"
                maxLength={16}
                autoComplete="off"
              ></input>
            )}
            {status && (
              <p
                className={
                  status === "success"
                    ? "popup__status"
                    : "popup__status popup__status_error"
                }
              >
                {status === "success"
                  ? openUserPopup.type === "addSlaveUser"
                    ? "Пользователь успешно добавлен!"
                    : "Данные успешно изменены!"
                  : "Что-то пошло не так"}
              </p>
            )}
            <button type="submit" className="popup__button" disabled={!isValid}style={{backgroundColor:$SiteColors.getState().backBtnSubmit}}>
              {showLoader ? <Preloader small /> : "Сохранить"}
            </button>
          </form>
        </div>
      </div>
    )
  );
};
